module.exports = __webpack_public_path__ + "static/media/browser.a7f2d5d7.png";